import { c as _c } from "react/compiler-runtime";
import { Switch, Button } from "@flat-ui";
import { isToolButtonItem, isToolThemeModeItem, isToolToggleItem } from "@components/dev-features-dialog/features-utils";
import { ThemeModeToggle } from "@components/common/theme-mode-toggle";
/**
 * @returns The control of the Dev tools table that allows to modify the tool state
 */
export function DevToolControl(t0) {
  const $ = _c(10);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = isToolToggleItem(item) && <Switch checked={!!item.isEnabled} onToggle={() => item.onToggle?.(!item.isEnabled)} label="" sx={{
      justifySelf: "end",
      overflow: "hidden"
    }} />;
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== item) {
    t2 = isToolButtonItem(item) && <Button variant="secondary" onClick={item.onClick} size="s">{item.buttonText}</Button>;
    $[2] = item;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== item) {
    t3 = isToolThemeModeItem(item) && <ThemeModeToggle />;
    $[4] = item;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}